export default [
    {
        path: '/aboutUs',
        component: () => import('../components/pages/aboutUs/AboutUs.vue') ,
        meta: {
            title: '关于我们'
        }
    }

]